.container {
  position: relative;
}

.iframe {
  display: block;
  width: 100%;
  border: 0;
  overflow: visible;
  min-height: var(--app-main-height);
}
